import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
import {currentResource} from '../../util/utils';

export function canvasFormUpdatesReducer(state = initialState.canvasFormUpdates, action) {
	switch (action.type) {
		case types.GET_CANVAS_FORM_UPDATES: {
			let canvasFormUpdates = {
				formData: [],
				totalPages: 0,
				currentPage: 1
			};

			if (action.response && action.response.formData && action.response.formData.length > 0) {
				action.response.formData.forEach(function(item) {
					let status = currentResource.canvasFormStatus.find((m) => m.id === item.formStatusId);
					canvasFormUpdates.formData.push({
						documentId: item.documentID,
						documentName: item.formName,
						formType: item.formTypeName,
						dateOfContent: item.approvalDate,
						formStatusId: item.formStatusId,
						formStatusValue: status?.value ?? '',
						isSelected: false,
						standard: item.standard,
						language: item.language,
						digital: item.gamLayers?.digital,
						complex: item.gamLayers?.complex,
						listed: item.gamLayers?.listed,
						PCBIA: item.gamLayers?.pcaobia,
						PCBFS: item.gamLayers?.pcaobfs,
						groupAudit: item.gamLayers?.groupAudit,
						isUpdateRestricted: item.isUpdateRestricted
					});
				});
				canvasFormUpdates.totalPages = action.response.totalPages;
				canvasFormUpdates.currentPage = action.response.page;
			}

			return canvasFormUpdates;
		}
		case types.CLEAR_CANVAS_FORM_UPDATES:
			let canvasFormUpdates = {
				formData: [],
				totalPages: 0,
				currentPage: 1
			};
			return canvasFormUpdates;
		default:
			return state;
	}
}
